// Panels

import $ from "jquery";

/**
 * Utility to select all panel's content blocks.
 * Simplified version to use instead of bootstrap.Collapse()
 *
 * @param {String} selector - panel selector to get elements set with jQuery
 * @param {String} panelClass - panel className as BEM CSS block ('panel' is default)
 */

const attachPanelsHandler = (selector, panelClass = "panel") => {
  const targets = Array.from(document.querySelectorAll(selector));

  targets.forEach((elem) => {
    const panelBtn = $(elem).prev();
    const panelBlock = panelBtn.parent();

    if ($(elem).hasClass("show")) {
      $(elem).slideUp(500).removeClass("show");
      panelBtn.removeClass(panelClass + "__btn--open");
      panelBtn.children("button").attr("aria-expanded", "false");

      if (panelBlock.hasClass("active")) {
        panelBlock.removeClass("active");
      }
    } else {
      $(elem).slideDown(500).addClass("show");
      panelBtn.addClass(panelClass + "__btn--open");
      panelBtn.children("button").attr("aria-expanded", "true");

      if (panelBlock.hasClass("active")) {
        panelBlock.addClass("active");
      }
    }
  });
};

export const init = () => {
  //  Panels
  if (document.querySelector(".panel")) {
    $("section .panel").on("click", (ev) => {
      const elem = ev.target;
      const btn = $(elem).closest(".panel__btn");

      if (btn.length) {
        const target = btn.find("button[data-target]").data("target");

        attachPanelsHandler(target);
      }
    });
  }
};
